export const ControlVariant = {
  primary: "primary",
  secondary: "secondary",
  basic: "basic",
  basicActive: "basicActive",
};
